import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContractContributionDTO  {
    _originalTypeClassName = "zERP.BO.EmployeeContractContributionDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContractContributionDTO.translate = translateService;
}
this.Id = null;
this.EmployeeContractContributionDTOKey = null;
this._key = this.EmployeeContractContributionDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
RuleDTO:any;
SpecialInsuranceCaseDTO:any;
SICProfessionPackageDTO:any;
private _EmployeeContractContributionDTOKey:any;
get EmployeeContractContributionDTOKey(): any {
    return this._EmployeeContractContributionDTOKey;
  }
set EmployeeContractContributionDTOKey(value: any) {
    this._EmployeeContractContributionDTOKey = value;
    this._key = value;
  }
static setRuleDTO = ($this, value) => {
var oldValue = $this.RuleDTO;
$this.RuleDTO = value;
if (value != null) {
}
}
static setSpecialInsuranceCaseDTO = ($this, value) => {
var oldValue = $this.SpecialInsuranceCaseDTO;
$this.SpecialInsuranceCaseDTO = value;
if (value != null) {
}
}
static setSICProfessionPackageDTO = ($this, value) => {
var oldValue = $this.SICProfessionPackageDTO;
$this.SICProfessionPackageDTO = value;
if (value != null) {
}
}

static Assign(ecc: any): any{let eccDTO = new Domain.EmployeeContractContributionDTO();
eccDTO.Id = eccDTO?.Id;
Domain.EmployeeContractContributionDTO.setRuleDTO(eccDTO, Domain.RuleDTO.AssignContribution(ecc?.Rule));
Domain.EmployeeContractContributionDTO.setSICProfessionPackageDTO(eccDTO, Domain.SICProfessionPackageDTO.Assign(ecc?.SICProfessionPackage));
Domain.EmployeeContractContributionDTO.setSpecialInsuranceCaseDTO(eccDTO, Domain.SpecialInsuranceCaseDTO.Assign(ecc?.SpecialInsuranceCase));
return eccDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeContractContributionDTOKey == null || $this.EmployeeContractContributionDTOKey == 0;
            }


}